import { cycleMappers } from './cycle.mappers';
export const mappers = {
  ...cycleMappers
};
//# sourceMappingURL=index.js.map